export const HOME = {
  homeTitle: 'Welcome to Empower',
  templatesTitle: 'Key initiatives for the company',
  upcomingTasks: 'Upcoming tasks',
  task: 'Task',
  owner: 'Owner',
  contributor: 'Contributor',
  dueDate: 'Due Date',
  status: 'Status',
  emptyStatus: 'You don’t currently have any pending tasks assigned to you',
  goToInitiative: 'Go to Initiatives',
  noAccess: 'You don’t have access to these features.',
  empowerText1:
    'Empower Action Planning can help you make a big impact on your employees’ experience',
  empowerText2:
    'If you are a manager and would like to start your own initiative, you can contact your QuestionPro system admin.',
  contactSupport:
    'Not sure who your system admin is? No problem. Contact  success@questionpro.com and we’ll help you get in touch with the  right person.',
  upgradeTo: 'Upgrade to',
  workforce: 'Workforce',
  licenseToUnlock: 'license to unlock these features',
  empower: 'empower',
  noPermissionDescription:
    'Empower allows users to get ongoing feedback from employees for their initiatives, get inspired, and start taking action towards making a big impact on their employee’s experience.',
  requestPricing: 'Request pricing',
  features: 'Features',
  employeeSurveys: 'Entire employee lifecycle surveys',
  '360feedback': '360 feedback',
  workforceAnalytics: 'Workforce analytics',
  support: '24/7 live chat, email and phone support',
  noPeople: 'No People',
  emptyTopContributors:
    'Top contributors are recognized for closing the highest number of tasks each week. Stay focused, complete your tasks, and lead your team to the top.',
} as const
